module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/092-sierra-leone-4d3d2619426c3e873f9485e4abe30212.svg";